export default __webpack_public_path__ + "static/media/Bird0.7df140a3.png";